import { server, port } from "./environment";

const URL = `${server}:${port}`;

const vendedorService = {
  async getVendedores() {
    try {
      const response = await fetch(`${URL}/api/vendedor/`);
      if (!response.ok) {
        throw new Error("Error al obtener los vendedores");
      }
      return await response.json();
    } catch (error) {
      console.error(error);
      return { error: error.message };
    }
  },

  async importVendedores(vendedores) {
    try {
      const response = await fetch(`${URL}/api/vendedor/import`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(vendedores),
      });
      if (!response.ok) {
        throw new Error("Error al importar los vendedores");
      }
      return await response.json();
    } catch (error) {
      console.error(error);
      return { error: error.message };
    }
  },
};

export default vendedorService;
